import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${props => props.theme.spacing.sp32};

  img {
    height: 100px;
    width: 100px;
  }

  p {
    color: ${props => props.theme.colors.text.subtle};
  }
`
